angular.module('FlexyBeautyApp.services').
    factory('UboView', ["Countries",
        function (Countries) {
            let UboView = function (ubo) {
                this.localId = null;
                this.firstName = null;
                this.lastName = null;
                this.isReadOnly = false;
                this.nationalityCountryCode = Countries.FRANCE.countryCode;
                this.address = {
                    addressLine1: null,
                    addressLine2: null,
                    city: null,
                    region: null,
                    postalCode: null,
                    countryCode: Countries.FRANCE.countryCode
                };

                this.birth = {
                    day: null,
                    city: null,
                    countryCode: Countries.FRANCE.countryCode,
                };

                if (ubo) {
                    this.loadDataFrom(ubo);
                }
            };

            UboView.prototype.loadDataFrom = function(ubo) {
                if (ubo.id) {
                    this.id = ubo.id;
                    this.localId = ubo.id;
                }

                this.firstName = ubo.firstName;
                this.lastName = ubo.lastName;
                this.nationalityCountryCode = ubo.nationalityCountryCode;
                this.address.addressLine1 = ubo.address.addressLine1;
                this.address.addressLine2 = ubo.address.addressLine2;
                this.address.city = ubo.address.city;
                this.address.region = ubo.address.region;
                this.address.postalCode = ubo.address.postalCode;
                this.address.countryCode = ubo.address.countryCode;
                this.birth.day = ubo.birth.day;
                this.birth.city = ubo.birth.city;
                this.birth.countryCode = ubo.birth.countryCode;
            };

            UboView.prototype.copyDataTo = function(ubo) {
                if (this.id) {
                    ubo.id = this.id;
                }
                ubo.firstName = this.firstName;
                ubo.lastName = this.lastName;
                ubo.nationalityCountryCode = this.nationalityCountryCode;
                ubo.address.addressLine1 = this.address.addressLine1;
                ubo.address.addressLine2 = this.address.addressLine2;
                ubo.address.city = this.address.city;
                ubo.address.region = this.address.region;
                ubo.address.postalCode = this.address.postalCode;
                ubo.address.countryCode = this.address.countryCode;
                ubo.birth.day = this.birth.day;
                ubo.birth.city = this.birth.city;
                ubo.birth.countryCode = this.birth.countryCode;
            };

            return UboView;
        }
    ]);



// WEBPACK FOOTER //
// ./js/services/views/UboView.js